import { MessageSquarePlus, Mail } from "lucide-react";
import { toast } from "sonner";

// FeedbackModal - Feedback und Feature Requests
const FeedbackModal = ({ 
  show,
  t,
  feedbackText,
  onFeedbackChange,
  onClose 
}) => {
  if (!show) return null;
  
  const handleClose = () => {
    onFeedbackChange('');
    onClose();
  };
  
  const handleFeatureSubmit = () => {
    if (feedbackText.trim()) {
      toast.success(t.feedbackSent || "Danke für dein Feedback!");
      onFeedbackChange('');
      onClose();
    }
  };
  
  return (
    <div 
      className="modal-overlay" 
      onClick={handleClose} 
      data-testid="feedback-modal-overlay"
    >
      <div 
        className="prompt-modal feedback-modal" 
        onClick={e => e.stopPropagation()} 
        data-testid="feedback-modal"
      >
        <h3 className="prompt-title">{t.feedbackTitle || "Feedback"}</h3>
        
        {/* Feature Request Section */}
        <div className="feedback-section">
          <p className="feedback-description">{t.feedbackFeatureTitle}</p>
          <textarea
            className="feedback-textarea"
            placeholder={t.feedbackFeaturePlaceholder}
            value={feedbackText}
            onChange={(e) => onFeedbackChange(e.target.value)}
            rows={3}
            data-testid="feedback-textarea"
          />
          <a
            href={`mailto:feedback@daily1.app?subject=${encodeURIComponent('Neuer Feature Request vom Nutzer')}&body=${encodeURIComponent(feedbackText)}`}
            className="prompt-btn primary feedback-btn"
            onClick={handleFeatureSubmit}
            data-testid="feedback-feature-btn"
          >
            <MessageSquarePlus size={16} />
            {t.feedbackFeatureButton}
          </a>
        </div>
        
        {/* Contact Section */}
        <div className="feedback-section feedback-contact">
          <p className="feedback-description">{t.feedbackContactTitle}</p>
          <a
            href="mailto:hello@daily1.app"
            className="prompt-btn secondary feedback-btn"
            onClick={onClose}
            data-testid="feedback-contact-btn"
          >
            <Mail size={16} />
            {t.feedbackContactButton}
          </a>
        </div>
        
        <button 
          className="prompt-btn tertiary" 
          onClick={handleClose}
          data-testid="feedback-close-btn"
        >
          {t.feedbackClose || "Schließen"}
        </button>
      </div>
    </div>
  );
};

export default FeedbackModal;
